module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-180x180.2eb51a024294641f8a5027f3aa74a2fe.png";